import { render, staticRenderFns } from "./Switch.vue?vue&type=template&id=d5c39532&scoped=true&"
import script from "./Switch.vue?vue&type=script&lang=js&"
export * from "./Switch.vue?vue&type=script&lang=js&"
import style0 from "./Switch.vue?vue&type=style&index=0&id=d5c39532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c39532",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5c39532')) {
      api.createRecord('d5c39532', component.options)
    } else {
      api.reload('d5c39532', component.options)
    }
    module.hot.accept("./Switch.vue?vue&type=template&id=d5c39532&scoped=true&", function () {
      api.rerender('d5c39532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/Switch.vue"
export default component.exports